export default "__VITE_ASSET__msCvQluL__"